export interface VisitedLinkModel {
  $visited: boolean;
}
